import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { CookieService } from 'ngx-cookie-service';
import { map, Observable, of } from 'rxjs';
import { TOKEN_REFRESH, TOKEN_VERIFY } from './token.graphql';
import { UserService } from '../user/user.service';
import { environment } from '../../../environments/environment';
import { craeateHeaders } from '../auth/auth.utills';

const COOKIE_OPTIONS = {
  path: '/',
};

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  constructor(
    private cookieService: CookieService,
    private userService: UserService,
    private apollo: Apollo,
  ) {}

  set idToken(idToken: string) {
    this.cookieService.delete('idToken');
    if (idToken) this.cookieService.set('idToken', idToken, COOKIE_OPTIONS);
  }

  get idToken(): string {
    return this.cookieService.get('idToken');
  }

  set accessToken(accessToken: string) {
    this.cookieService.delete(`${environment.scattre.account}+saleor_auth_access_token`);
    if (accessToken)
      this.cookieService.set(
        `${environment.scattre.account}+saleor_auth_access_token`,
        accessToken,
        COOKIE_OPTIONS,
      );
  }

  get accessToken(): string {
    return this.cookieService.get(`${environment.scattre.account}+saleor_auth_access_token`);
  }

  set refreshToken(refreshToken: string) {
    this.cookieService.delete(`${environment.scattre.account}+saleor_auth_refresh_token`);
    if (refreshToken)
      this.cookieService.set(
        `${environment.scattre.account}+saleor_auth_refresh_token`,
        refreshToken,
        COOKIE_OPTIONS,
      );
  }

  get refreshToken(): string {
    return this.cookieService.get(`${environment.scattre.account}+saleor_auth_refresh_token`);
  }

  public tokenVerify(): Observable<boolean> {
    if (!this.accessToken) return of(false);

    const headers = craeateHeaders();
    const options: any = this.setQueryOptions(TOKEN_VERIFY, headers);

    return this.apollo
      .use('account')
      .watchQuery(options)
      .valueChanges.pipe(
        map((res: any) => {
          if (!res.data.me) return false;
          this.userService.userData = {
            id: res.data.me.id,
            email: res.data.me.email,
            name: `${res.data.me.lastName}${res.data.me.firstName}`,
            loginType: res.data.me.loginType,
          };

          return res.data.me;
        }),
      );
  }

  private setQueryOptions(query: any, headers: Headers) {
    const options: any = {};

    options.query = query;
    options.errorPolicy = 'all';
    options.context = {
      headers,
    };

    return options;
  }

  public refresh(): Observable<any> {
    return this.apollo
      .use('account')
      .mutate({
        mutation: TOKEN_REFRESH,
        variables: {
          refreshToken: this.refreshToken,
        },
      })
      .pipe(map((res: any) => res.data?.tokenRefresh?.token));
  }
}
